import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import EditPersonalInformation from "./editPersonalInformation";
import usePersonalInformation from "./usePersonalInformation";
import PersonalInformation from "./personalInformation";
import { scrollIntoView } from "utils/helper";

function Index({ isShowEditIcon }) {
  const [t] = useTranslation();
  const [isEditMode, setIsEditMode] = useState(false);
  const { onEditSave, isLoading } = usePersonalInformation();

  const handleEditClick = () => {
    setIsEditMode(true);
  };

  const handleDiscard = () => {
    setIsEditMode(false);
    scrollIntoView("personalDetailsScrollId");
  };

  const handleSave = async (values) => {
    await onEditSave(values);
    setIsEditMode(false);
  };

  if (isEditMode) {
    return (
      <EditPersonalInformation
        onDiscard={handleDiscard}
        onSave={handleSave}
        isLoading={isLoading}
      />
    );
  }

  return (
    <PersonalInformation
      onEditClick={handleEditClick}
      isShowEditIcon={isShowEditIcon}
    />
  );
}

export default Index;
